import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';

document.querySelectorAll('[data-acc02-mosaic-mobile]').forEach(function (wrap) {
  var sliderEl = wrap.querySelector('.acc02-12__mobile-slider');
  if (!sliderEl) return;

  new Swiper(sliderEl, {
    slidesPerView: 1,
    spaceBetween: 16,
    autoHeight: true,
    navigation: {
      prevEl: wrap.querySelector('[data-acc02-mosaic-prev]'),
      nextEl: wrap.querySelector('[data-acc02-mosaic-next]')
    },
    breakpoints: {
      500: { slidesPerView: 1.5 }
    }
  });
});
